import classNames from 'classnames'
import { FiChevronLeft } from 'react-icons/fi'

/** The /t/ page's own words for each stage, so the two never disagree. */
export const TRANSFER_STAGE_LABELS: Record<TLoanTransferStage, string> = {
    in_review: 'در حال بررسی',
    at_bank: 'ارسال شده به بانک مقصد',
    landed: 'واریز شد',
    failed: 'ناموفق',
}

export const TRANSFER_STAGE_TONE: Record<TLoanTransferStage, string> = {
    in_review: 'bg-warning-soft text-warning-on',
    at_bank: 'bg-warning-soft text-warning-on',
    landed: 'bg-success-2 text-success-on',
    failed: 'bg-danger-soft text-danger-on',
}

/**
 * «پیگیری واریز» — the way from a payout to the public /t/<code>/ page that
 * says where the money is. It is the same page the recipient's SMS carries, so
 * a member and a manager asking «رسید؟» are looking at one answer.
 *
 * A real link rather than a button: it leaves the app (a backend-rendered page
 * on gethamyan.ir), and long-press / open-in-browser should work on it.
 */
export default function TransferTrackingLink({
    transfer,
    title = 'پیگیری واریز',
    onOpen,
    className,
}: {
    transfer: ILoanDemandTransfer
    title?: string
    /** analytics; the link itself needs no handler */
    onOpen?: () => void
    className?: string
}) {
    const label = TRANSFER_STAGE_LABELS[transfer.stage]
    return (
        <a
            href={transfer.tracking_url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onOpen}
            className={classNames(
                'flex min-h-[44px] items-center justify-between gap-2 rounded-xl border border-stroke bg-canvas px-3 py-2 active:bg-divider',
                className
            )}
        >
            <span className="text-xs font-bold text-brand-deep">{title}</span>
            <span className="flex min-w-0 items-center gap-1.5">
                {label && (
                    <span
                        className={classNames(
                            'truncate rounded-full px-2 py-0.5 text-[10px] font-bold',
                            TRANSFER_STAGE_TONE[transfer.stage]
                        )}
                    >
                        {label}
                    </span>
                )}
                <FiChevronLeft
                    aria-hidden
                    className="h-4 w-4 shrink-0 text-text-muted"
                />
            </span>
        </a>
    )
}
